export default __webpack_public_path__ + "static/media/object.9e039653.mp3";